<button class="eau-connection-indicator--outer eau-btn-link"
    title="{{'tooltip.connection_status' | translate}}"
    (click)="onTogglePopover()">
    <span class="eau-connection-indicator" [ngClass]="className$ | async"></span>
</button>
